import React from 'react';
import PropTypes from 'prop-types';
import TimeInput from './TimeInput';
import ClearRowButton from './ClearRowButton';

class TimeInputRow extends React.Component {
  render() {
    const { title,
      inputType,
      userPayrolls,
      onInputChange,
      onInputFocus,
      clz,
      manualMode,
      disabled,
      onClearRow
    } = this.props;

    return (
      <>
        <th className={`item ${clz || 'th2'}`} colSpan={clz == 'th1' ? '2' : '1'}>
          {onClearRow ? (
            <ClearRowButton title={title} onClear={onClearRow} />
          ) : (
            <span>{title}</span>
          )}
        </th>
        {userPayrolls.map((userPayroll, index) => {
          let value = userPayroll[inputType] === 0 ? 0 : userPayroll[inputType] || '';

          // MEMO Fix value for Tax2024 manual mode;
          value = inputType.match(/^tax2024_/) && value === '' && userPayroll['tax2024_number_of_family_members'] !== null ? 0 : value;

          return (
            <td className="salary w9" key={index}>
              <TimeInput className="inputTime w9"
                disabled={!disabled ? false : !manualMode ? true : value === ''}
                inputType={inputType}
                name={`payment[${userPayroll.uID}][${inputType}]`}
                onChange={(e) => onInputChange(e, index, inputType)}
                onFocus={(e) => onInputFocus(e, userPayroll.uID, inputType)}
                type="text"
                value={value}
              />
            </td>
          );
        })}
      </>
    );
  }
}

TimeInputRow.propTypes = {
  title: PropTypes.string.isRequired,
  inputType: PropTypes.string.isRequired,
  userPayrolls: PropTypes.array.isRequired,
  onInputChange: PropTypes.func.isRequired,
  onInputFocus: PropTypes.func.isRequired,
  optionAttributes: PropTypes.array.isRequired,
  clz: PropTypes.string.isOptional,
  manualMode: PropTypes.bool.isOptional,
  disabled: PropTypes.bool.isOptional,
  onClearRow: PropTypes.func
};

export default TimeInputRow;
